// @ts-nocheck
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Avatar,
  Chip,
  IconButton,
  Link as MuiLink,
  Grid,
  CardMedia,
  CircularProgress,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CreateContentModal from "modules/MyContent/components/MyContentData/CreateContentModal";
import { useAuth } from "context/authContext";
import { useParams, useNavigate } from "react-router-dom";
import { ContentsService } from "services/ContentsService";
import { Content as ContentType } from "types/types";
import dayjs from "dayjs";
import { CartService } from "services/CartService";
import { PurchasesService } from "services/PurchasesService";

const ReviewEduContentData = () => {
  const { currentUser, isLoggedIn } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const [contentEduData, setContentEduData] = useState<ContentType | null>(
    null
  );
  console.log("contentEduData", contentEduData);

  const isCreator = currentUser?.uid === contentEduData?.createdBy?.id;

  const [loading, setLoading] = useState(true);
  const [activeSection, setActiveSection] = useState("expect");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalLogin, setModalLogin] = useState(false);
  const [isPurchased, setIsPurchased] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await ContentsService.getContentById(id);
        setContentEduData(data as ContentType);
        // console.log("dataaa", data);

        // Fetch `createdBy` user details if `createdBy` exists
        if (data.createdBy) {
          const userData = await ContentsService.getUserByCreatedBy(data.createdBy);
          //@ts-ignore
          // Append `createdBy` user data to `contentEduData`
          setContentEduData((prevData) => ({
            ...prevData,
            createdBy: userData,
          }));
        }

        if (!currentUser) return;

        // Fetch purchase history
        const purchasedItems = await PurchasesService.getPurchasesByUser(
          currentUser.uid
        );

        // Check if the content has already been purchased
        const purchased = purchasedItems.some(
          (item) => item.contentId?.id === id // Use .id to extract the Firestore document ID
        );
        // console.log("purchased", { purchased, id });

        setIsPurchased(purchased);
      } catch (error) {
        console.error("Error fetching content data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, currentUser]);

  const handleSectionChange = (section: string) => {
    setActiveSection(section);
  };
  const handleCreateContentClick = async () => {
    if (!isLoggedIn) {
      // Prompt the user to log in
      setModalLogin(true);
      return;
    }

    if (!contentEduData) {
      console.error("No content data available");
      return;
    }

    try {
      const {
        id: contentId,
        price,
        type,
        title,
        coverPhotoUrl,
        category,
      } = contentEduData;
      const tax = price * 0.1;
      const subTotal = price + tax;
      // Add content to cart
      const cartId = await CartService.addToCart(
        currentUser.uid,
        contentId,
        subTotal,
        tax,
        "pending",
        {
          title,
          image: coverPhotoUrl || "/default-image.png", // Default image fallback
          price,
          category: category || "General",
          type,
          quantity: 1,
          afterCoupon: price,
        }
      );


      // Redirect or open a modal based on content type
      if (type === "handout") {
        setModalOpen(true);
      } else {
        navigate(`/cart`); // Redirect to cart page for course
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  // Function to handle "Personal" button click
  const handlePersonalClick = async (cartId: string) => {
    navigate(`/cart`);
    await handleCreateContentClick();
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalLogin(false);
  };

  const handleRegiter = () => {
    navigate("/register");
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const handleRedHandout = () => {
    navigate("/education-content-handout");
  };

  if (loading) return <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="40vh"
    width="100vw"
  >
    <CircularProgress color="primary" size={60} />
  </Box>;

  if (!contentEduData) return <div>No data found for this content.</div>;


  return (
    <Box sx={styleSheet.mainContainer}>

      <Box sx={styleSheet.headerContainer}>
        Drawing Fundamentals 1: {contentEduData?.title}
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={2}>
        <Box
          display={"flex"}
          justifyContent={"center"}
          // justifyContent={{xs:"start", md:"center"}}
          flexWrap={{ xs: "wrap", lg: "nowrap", md: "wrap", xl: "nowrap" }}
          gap={6}
        >
          <CardMedia
            sx={{
              width: { xs: "253.37px", md: "577px" },
              height: { xs: "199.36px", md: "490px" },
              borderRadius: { xs: "6.59px", md: "15px" },
              objectFit: "cover",
            }}
            image={
              contentEduData?.coverPhotoUrl || "/assets/icons/education.png"
            }
          />
          {/* <img src="/assets/icons/education.png" alt="education"
                    /> */}

          <Box sx={styleSheet.cardContainer}>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              flexWrap={{ xs: "wrap", md: "nowrap" }}
              gap={{ xs: 2, md: 0 }}
              alignItems={"center"}
            >
              <Typography
                fontSize={{ xs: "21.58px", md: "28px" }}
                fontWeight={500}
                color={"#218F40"}
              >
                ${contentEduData?.price}
              </Typography>

              <Button
                onClick={handleCreateContentClick}
                sx={{
                  ...styleSheet.addToCardBtn,
                  "&.Mui-disabled": {
                    color: "#FFFFFF", // ✅ Keep text color consistent
                    backgroundColor: "#A0A0A0",// ✅ Keep background color the same
                    opacity: 1, // ✅ Remove the default opacity effect
                  },
                }}
                // disabled={isPurchased}
                disabled={isPurchased || isCreator} // Disable for the creator


              >
                <ShoppingCartIcon
                  fontSize="small"
                  sx={{
                    mr: { xs: 4, md: 4 },
                  }}
                />
                {isCreator ? "You can't buy your own content" : isPurchased ? "Already Purchased" : "Add to Cart"}

                {/* {isPurchased ? "Already Purchased" : "Add to Cart"} */}
              </Button>
            </Box>
            {/* /// modal this  /// */}
            <CreateContentModal
              open={isModalOpen}
              onClose={handleCloseModal}
              onCourseClick={handlePersonalClick}
              onHandoutClick={handleRedHandout}
              heading="Is this purchase for personal use or for a group?"
              buttonText1="Personal"
              buttonText2="For a Group"
              headingColor="#233F91"
            />
            {/* /// modal login redirect  /// */}
            <CreateContentModal
              open={isModalLogin}
              onClose={handleCloseModal}
              heading="Login Required to Continue"
              headingColor="#FF0000"
              text="Figma ipsum component variant main layer. Distribute link object effect create editor flatten link. Asset create bullet library figma vector edit move pen slice. Component flows flows team effect pencil main bullet component. Hand export project arrange pencil selection edit background background. Library align."
              buttonText1="Register"
              buttonBgColor1="#EEEEEE"
              textColor="#233F91"
              onCourseClick={handleRegiter}
              buttonText2="Log in"
              onHandoutClick={handleLogin}
            />
            <Typography
              fontSize={{ xs: "13.87px", md: "18px" }}
              fontWeight={700}
              color={"#797979"}
            >
              Content Details
            </Typography>
            <Grid display={"flex"} alignItems={"center"} gap={1}>

              <Avatar
                alt="Remy Sharp"
                src={
                  //@ts-ignore
                  contentEduData?.createdBy?.profileUrl ||
                  "/static/images/avatar/1.jpg"
                }
                sx={{ width: { xs: 30, md: 40 }, height: { xs: 30, md: 40 } }}
              />

              <Box
                fontSize={{ xs: "13.1px", md: "17px" }}
                fontWeight={700}
                color={"#000000"}
              >

                {
                  //@ts-ignore
                  contentEduData?.createdBy?.firstName
                    //@ts-ignore
                    ? `${contentEduData?.createdBy?.firstName} ${contentEduData?.createdBy?.lastName || ""
                    }`
                    : "Serra Ozkaragoz"}
              </Box>
            </Grid>
            <Grid display={"flex"} alignItems={"center"} gap={1}>
              <CardMedia
                color="primary"
                sx={{
                  width: { xs: "15.41px", md: "29px" },
                  height: { xs: "15.41px", md: "29px" },
                }}
                image="/assets/icons/source.svg"
              />
              <Box component="span" sx={styleSheet.textHeading}>
                {/* {contentEduData?.sourceOfKnowledge} */}
                {Array.isArray(contentEduData?.sourceOfKnowledge)
                  ? contentEduData?.sourceOfKnowledge.join(', ')
                  : contentEduData?.sourceOfKnowledge.replace(/\//g, ' / ')}
              </Box>
            </Grid>
            <Grid display={"flex"} alignItems={"center"} gap={1}>
              <CardMedia
                color="primary"
                sx={{
                  width: { xs: "15.41px", md: "29px" },
                  height: { xs: "15.41px", md: "29px" },
                }}
                image="/assets/icons/category.svg"
              />
              <Box sx={styleSheet.textHeading}>
                {/* {contentEduData?.category} */}
                {Array.isArray(contentEduData?.category)
                  ? contentEduData?.category.join(', ')
                  : contentEduData?.category.replace(/\//g, ' / ')}
              </Box>
            </Grid>
            <Grid display={"flex"} alignItems={"center"} gap={1}>
              <CardMedia
                sx={{
                  width: { xs: "13.87px", md: "30px" },
                  height: { xs: "13.87px", md: "30px" },
                  objectFit: "cover",
                }}
                image="/assets/icons/type.svg"
              />
              <Box sx={styleSheet.textHeading}>
                {contentEduData?.type
                  ? contentEduData.type.charAt(0).toUpperCase() +
                  contentEduData.type.slice(1)
                  : ""}
              </Box>{" "}
            </Grid>
            <Grid display={"flex"} alignItems={"center"} gap={1}>
              <CardMedia
                sx={{
                  width: { xs: "13.87px", md: "26px" },
                  height: { xs: "13.87px", md: "26px" },
                  objectFit: "cover",
                }}
                image="/assets/icons/date.svg"
              />

              <Box sx={styleSheet.textHeading}>
                {contentEduData?.createdAt
                  ? dayjs(contentEduData.createdAt.toDate()).format(
                    "MM/DD/YYYY"
                  )
                  : ""}
              </Box>
            </Grid>
            <Grid
              display={{
                xs: "none",
                md: "flex",
              }}
              alignItems={"center"}
              gap={1}
            >
              <CardMedia
                sx={{
                  width: { xs: "13.87px", md: "60px" },
                  height: { xs: "13.87px", md: "30px" },
                  objectFit: "cover",
                }}
                image="/assets/icons/que.svg"
              />
              <Box sx={{ ...styleSheet.textHeading, fontSize: "14px" }}>
                If you are purchasing this {contentEduData?.type} for a group,
                please adjust the quantity in your cart to match the number of
                participants{" "}
              </Box>
            </Grid>
          </Box>
        </Box>
        <Typography
          sx={{
            mx: { xs: 2, md: 0 },
            borderBottom: "1px solid #F0F0F0",
            mt: 2,
          }}
        ></Typography>
        <Box
          display={"flex"}
          mx={{ xs: 2, md: 0 }}
          flexDirection={"column"}
          gap={1}
        >
          <Box display={"flex"} gap={{ xs: 3, md: 8 }}>
            <Typography
              onClick={() => handleSectionChange("expect")}
              fontWeight={700}
              fontSize={"18px"}
              color={activeSection === "expect" ? "#233F91" : "#676767"}
              sx={{
                position: "relative",
                cursor: "pointer",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: "100%",
                  height: "4px",
                  bottom: "-8px",
                  borderTopRightRadius: "5px",
                  borderTopLeftRadius: "5px",
                  left: 0,
                  backgroundColor:
                    activeSection === "expect" ? "#233F91" : "transparent",
                },
              }}
            >
              What to Expect from this Content
            </Typography>
            <Typography
              onClick={() => handleSectionChange("summary")}
              fontWeight={700}
              fontSize={"18px"}
              color={activeSection === "summary" ? "#233F91" : "#676767"}
              sx={{
                position: "relative",
                cursor: "pointer",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: "100%",
                  height: "4px",
                  bottom: "-8px",
                  borderTopRightRadius: "5px",
                  borderTopLeftRadius: "5px",
                  left: 0,
                  backgroundColor:
                    activeSection === "summary" ? "#233F91" : "transparent",
                },
              }}
            >
              Summary
            </Typography>
          </Box>

          <Typography
            sx={{ mx: { xs: 2, md: 0 }, borderBottom: "1px solid #F0F0F0" }}
          ></Typography>
        </Box>
        {activeSection === "expect" && (
          <Box
            display={"flex"}
            mx={{ xs: 2, md: 0 }}
            flexDirection={"column"}
            gap={3}
            mb={{ xs: 3, md: 0 }}
          >
            <Typography sx={styleSheet.content}>
              {contentEduData?.expectations}

            </Typography>

          </Box>
        )}

        {activeSection === "summary" && (
          <Box
            display={"flex"}
            mx={{ xs: 2, md: 0 }}
            flexDirection={"column"}
            gap={3}
            mb={{ xs: 3, md: 0 }}
          >
            <Typography sx={styleSheet.content}>
              {contentEduData?.summary}

            </Typography>

          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ReviewEduContentData;

const styleSheet = {
  mainContainer: {
    width: { xs: "100%", md: "1103px" },
    p: { xs: 0, md: 5 },
  },
  headerContainer: {
    pt: { xs: 15, md: 3 },
    pb: 3,
    fontWeight: 500,
    fontSize: { xs: "23px", md: "28px" },
    color: "#233F91",
    width: { xs: "100 %", md: "431px" },
    px: { xs: 2, md: 0 },
  },
  cardContainer: {
    borderRadius: "15px",
    display: "flex",
    boxShadow: "0px 1px 1px 1px rgba(0, 0, 0, 0.25)",
    p: { xs: 2, md: 3 },
    flexDirection: "column",
    border: "1px solid #F2F2F2",
    gap: 3,
    width: { xs: "322px", md: "462px" },
    // mt: 2,
  },
  addToCardBtn: {
    width: "301px",
    height: { xs: "43px", md: "57px" },
    borderRadius: { xs: "7.93px", md: "15px" },
    bgcolor: "#233F91",
    fontSize: { xs: "13.1px", md: "17px" },
    fontWeight: "400",

    color: "#fff",
    "&.Mui-disabled": {
      color: "#FFFFFF", // Keep the text color consistent when disabled
      backgroundColor: "#233F91", // Ensure the background color doesn't change
      opacity: 1, // Prevent the button from appearing faded
    },
    "&:hover": {
      bgcolor: "#1A73E8",
    },
  },
  textHeading: {
    fontSize: { xs: "13.1px", md: "17px" },
    fontWeight: 400,
    color: "#676767",
  },

  content: {
    mt: 2,
    fontSize: { xs: "20px", md: "22px" },
    fontWeight: 400,
    color: "#676767",
  },
};
